import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/icons/add.png'


const _withScopeId = n => (_pushScopeId("data-v-5bc22b82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container mt-8 content-start items-start" }
const _hoisted_2 = { class: "flex col-start-1 col-end-13 justify-between items-center-w-full" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "ac-large-title" }, "Şantiyeler", -1))
const _hoisted_4 = { class: "action-row col-start-1 col-end-13 flex items-center justify-end gap-6" }
const _hoisted_5 = { class: "flex items-center gap-2 text-xl cursor-pointer" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mr-4 filter-white",
  width: "20",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_7 = {
  key: 0,
  class: "alt-table col-start-1 col-end-13 w-full mt-5"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Renk"),
    /*#__PURE__*/_createElementVNode("th", null, "Şantiye"),
    /*#__PURE__*/_createElementVNode("th", null, "Lokasyon"),
    /*#__PURE__*/_createElementVNode("th", null, "Durum"),
    /*#__PURE__*/_createElementVNode("th", null, "İşlemler")
  ])
], -1))
const _hoisted_9 = { class: "text-overflow w-24" }
const _hoisted_10 = { class: "text-overflow" }
const _hoisted_11 = { class: "text-overflow" }
const _hoisted_12 = { class: "text-overflow" }
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]

import { ref, computed, onBeforeMount, onBeforeUnmount } from "vue"
import { useGetDocs, postData, updateMeta, deleteData } from "../../mixins/modularFirebaseOperations"
import { modalClosed } from "../../mixins/visualFormatters"
import AcMediumModal from "../reusable/teleports/acMediumModal.vue"
import InventoryMetaForm from "../reusable/form-widgets/inventoryMetaForm.vue"
import resetBackground from "@/mixins/resetBackground"
import removeBackground from "@/mixins/removeBackground"
import type { AcInventoryWorksite } from "../../types/inventory"

const COLLECTION = "inventory/worksites/list"


export default /*#__PURE__*/_defineComponent({
  __name: 'inventoryWorksites',
  setup(__props) {


const isAddingMeta = ref<boolean>(false)
const editedMeta = ref<AcInventoryWorksite | undefined>(undefined)
const showInactive = ref<boolean>(false)
const { docs, isLoadingDocs } = useGetDocs<AcInventoryWorksite>(COLLECTION)

// By default only active worksites are listed; inactive ones are revealed on demand.
const visibleMetas = computed(() =>
    showInactive.value ? docs.value : docs.value.filter((meta) => meta.isActive)
)

const handleAddMeta = async function(meta: AcInventoryWorksite) {
    const newMeta = { ...meta, isActive: true }
    const docRef = await postData(newMeta, COLLECTION)
    docs.value.push({ ...newMeta, id: docRef as string })
    isAddingMeta.value = false
    modalClosed()
}

const handleDelete = async function(metaId: string) {
    if (!confirm("Bu şantiyeyi silmek istediğinize emin misiniz?")) return
    await deleteData(COLLECTION, metaId)
    docs.value = docs.value.filter((meta) => meta.id !== metaId)
}

const handleUpdatedData = async function(meta: AcInventoryWorksite) {
    await updateMeta(COLLECTION, meta.id!, meta)
    const updatedMeta = docs.value.find((existingMeta) => existingMeta.id === meta.id)
    if (updatedMeta) {
        updatedMeta.name = meta.name
        updatedMeta.location = meta.location
        updatedMeta.color = meta.color
    }
    editedMeta.value = undefined
    modalClosed()
}

const toggleActive = async function(meta: AcInventoryWorksite & { id: string }) {
    const newValue = !meta.isActive
    await updateMeta(COLLECTION, meta.id, { isActive: newValue })
    meta.isActive = newValue
}

onBeforeMount(() => {
  removeBackground.methods.removeBackground()
})

onBeforeUnmount(() => {
  resetBackground.methods.resetBackground()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showInactive).value = $event))
          }, null, 512), [
            [_vModelCheckbox, showInactive.value]
          ]),
          _createTextVNode(" Pasif şantiyeleri göster ")
        ]),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (isAddingMeta.value = true)),
          class: "ac-add-button"
        }, [
          _hoisted_6,
          _createTextVNode(" Yeni Şantiye Ekle ")
        ])
      ])
    ]),
    (!_unref(isLoadingDocs))
      ? (_openBlock(), _createElementBlock("table", _hoisted_7, [
          _hoisted_8,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleMetas.value, (meta) => {
            return (_openBlock(), _createElementBlock("tr", {
              class: "hover:bg-gray-200 relative cursor-pointer",
              key: meta.id
            }, [
              _createElementVNode("td", _hoisted_9, [
                _createElementVNode("div", {
                  class: "w-6 h-6 rounded-full",
                  style: _normalizeStyle({ backgroundColor: meta.color })
                }, null, 4)
              ]),
              _createElementVNode("td", _hoisted_10, _toDisplayString(meta.name), 1),
              _createElementVNode("td", _hoisted_11, _toDisplayString(meta.location || "-"), 1),
              _createElementVNode("td", _hoisted_12, [
                _createElementVNode("span", {
                  class: _normalizeClass(meta.isActive ? 'status-pill status-pill--active' : 'status-pill status-pill--inactive')
                }, _toDisplayString(meta.isActive ? "Aktif" : "Pasif"), 3)
              ]),
              _createElementVNode("td", _hoisted_13, [
                _createElementVNode("button", {
                  type: "button",
                  class: "table-button",
                  onClick: ($event: any) => (toggleActive(meta))
                }, _toDisplayString(meta.isActive ? "Pasife Al" : "Aktife Al"), 9, _hoisted_14),
                _createElementVNode("button", {
                  type: "button",
                  class: "table-button",
                  onClick: ($event: any) => (editedMeta.value = meta)
                }, " Düzenle ", 8, _hoisted_15),
                _createElementVNode("button", {
                  type: "button",
                  class: "table-button",
                  onClick: ($event: any) => (handleDelete(meta.id!))
                }, " Sil ", 8, _hoisted_16)
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, {
        appear: "",
        type: "animation",
        "enter-active-class": "animate__animated animate__fadeIn animate__fast",
        "leave-active-class": "animate__animated animate__fadeOut animate__faster"
      }, {
        default: _withCtx(() => [
          (isAddingMeta.value || editedMeta.value)
            ? (_openBlock(), _createBlock(AcMediumModal, {
                key: 0,
                class: "lg:!top-44 overflow-y-scroll",
                onModalClosed: _cache[4] || (_cache[4] = ($event: any) => {isAddingMeta.value = false; editedMeta.value = undefined}),
                height: "fit-content",
                width: "40vw",
                title: "Şantiye"
              }, {
                default: _withCtx(() => [
                  _createVNode(InventoryMetaForm, {
                    metaTitle: "Şantiye",
                    hasColor: true,
                    hasLocation: true,
                    existingMeta: editedMeta.value,
                    onMetaAdded: _cache[2] || (_cache[2] = ($event: any) => (handleAddMeta($event))),
                    onMetaUpdated: _cache[3] || (_cache[3] = ($event: any) => (handleUpdatedData($event)))
                  }, null, 8, ["existingMeta"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ]))
}
}

})